// extracted by mini-css-extract-plugin
module.exports = {"content-field":"content-field--QKVHV","title":"title--1C9dN","children":"children--HZnRX"};